export const PUBLIC_URL = process.env.PUBLIC_URL || "http://localhost:3000/"
export const AUTH_URL = process.env.AUTH_URL || "https://auth.my-sites-guard.com/"
const RAW_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:4000/";
const NORMALIZED_BACKEND_URL = RAW_BACKEND_URL.replace(/\/$/, "");

export const BACKEND_URL = RAW_BACKEND_URL;
export const BACKEND_PATH = process.env.REACT_APP_BACKEND_PATH || "/api-socket";

const SOCKET_PATH_HINT = BACKEND_PATH.toLowerCase().includes("socket");
const DEFAULT_HTTP_BASE = process.env.REACT_APP_BACKEND_HTTP_URL
    || (SOCKET_PATH_HINT
        ? NORMALIZED_BACKEND_URL
        : `${NORMALIZED_BACKEND_URL}${BACKEND_PATH.startsWith("/") ? BACKEND_PATH : `/${BACKEND_PATH}`}`.replace(/\/$/, ""));

export const BACKEND_HTTP_URL = DEFAULT_HTTP_BASE.replace(/\/?$/, "/");
export const BUILD_ID = process.env.REACT_APP_BUILD_ID
    || process.env.BUILD_ID
    || new Date().toISOString();
export const GoogleOAuthClientID = process.env.GoogleOAuthClientID || "337223163181-580kubd5ipvaq902mgnsl8gdrnigac75.apps.googleusercontent.com"
export const GoogleOAuthClientSecert = process.env.GoogleOAuthClientSecert || "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"
export const PRODUCT_ID = parseInt(process.env.REACT_APP_PRODUCT_ID || "1", 10);
